import { render, staticRenderFns } from "./BriefContentPanel.vue?vue&type=template&id=449ffa89&scoped=true"
import script from "./BriefContentPanel.vue?vue&type=script&lang=js"
export * from "./BriefContentPanel.vue?vue&type=script&lang=js"
import style0 from "./BriefContentPanel.vue?vue&type=style&index=0&id=449ffa89&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ffa89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449ffa89')) {
      api.createRecord('449ffa89', component.options)
    } else {
      api.reload('449ffa89', component.options)
    }
    module.hot.accept("./BriefContentPanel.vue?vue&type=template&id=449ffa89&scoped=true", function () {
      api.rerender('449ffa89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/briefs/BriefContentPanel.vue"
export default component.exports